/**
 * 菜单管理API
 */
import request from '@/utils/request'

/**
 * 获取菜单列表
 */
export function getMenus(params) {
  return request({
    url: '/api/v1/menus',
    method: 'get',
    params
  })
}

/**
 * 获取菜单树
 */
export function getMenuTree(params) {
  return request({
    url: '/api/v1/menus/tree',
    method: 'get',
    params
  })
}

/**
 * 获取菜单详情
 */
export function getMenuById(id) {
  return request({
    url: `/api/v1/menus/${id}`,
    method: 'get'
  })
}

/**
 * 创建菜单
 */
export function createMenu(data) {
  return request({
    url: '/api/v1/menus',
    method: 'post',
    data
  })
}

/**
 * 更新菜单
 */
export function updateMenu(id, data) {
  return request({
    url: `/api/v1/menus/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除菜单
 */
export function deleteMenu(id) {
  return request({
    url: `/api/v1/menus/${id}`,
    method: 'delete'
  })
}

/**
 * 获取角色的菜单权限
 */
export function getRoleMenus(roleId, params) {
  return request({
    url: `/api/v1/menus/roles/${roleId}/menus`,
    method: 'get',
    params
  })
}

/**
 * 为角色添加菜单权限
 */
export function addRoleMenu(roleId, data) {
  return request({
    url: `/api/v1/menus/roles/${roleId}/menus`,
    method: 'post',
    data
  })
}

/**
 * 批量为角色添加菜单权限
 */
export function batchAddRoleMenus(roleId, data) {
  return request({
    url: `/api/v1/menus/roles/${roleId}/menus/batch`,
    method: 'post',
    data
  })
}

/**
 * 批量更新角色菜单权限
 */
export function batchUpdateRoleMenuPermissions(roleId, data) {
  return request({
    url: `/api/v1/menus/roles/${roleId}/menus/batch`,
    method: 'put',
    data
  })
}

/**
 * 移除角色的菜单权限
 */
export function removeRoleMenu(roleId, menuId) {
  return request({
    url: `/api/v1/menus/roles/${roleId}/menus/${menuId}`,
    method: 'delete'
  })
}

/**
 * 获取当前用户的菜单权限（平铺列表）
 */
export function getMyMenuPermissions(params) {
  return request({
    url: '/api/v1/menus/users/me/menus',
    method: 'get',
    params
  })
}

/**
 * 获取当前用户的菜单树
 */
export function getMyMenuTree(params) {
  return request({
    url: '/api/v1/menus/users/me/menus/tree',
    method: 'get',
    params
  })
}

/**
 * 获取指定用户的菜单权限（管理员可查看）
 */
export function getUserMenuPermissions(userId, params) {
  return request({
    url: `/api/v1/menus/users/${userId}/menus`,
    method: 'get',
    params
  })
}

/**
 * 清除菜单缓存
 */
export function clearMenuCache() {
  return request({
    url: '/api/v1/menus/clear-cache',
    method: 'post'
  })
}

